import React from 'react'
import { Link } from 'react-router-dom';
import './blog.css'
import img1111 from './images/blogseo.webp'
import img1112 from './images/blogsmm.jpg'

export default function blog() {
    return (


        <>


            <section className="hero">
                <h1>Insights, Trends, and Tips on Digital Marketing</h1>
                <p>Stay updated with the latest in SEO, social media, PPC, content marketing, and more!</p>
                <Link to="#" className="cta-button">Subscribe for Updates</Link>
            </section>


            <section className="blog-posts">
                <h2>Recent Blog Posts</h2>
                <div className="post-grid">
                    <article className="post">
                        <img src={img1111} alt="blog seo" />
                        <h3>Serach Engine Optimization</h3>
                        <p>Make your webite ranking...</p>
                        <Link to="#" className="read-more">Read More</Link>
                    </article>
                    <article className="post">
                        <img src={img1112} alt="blogsmm" />
                        <h3>Social Media Marketing</h3>
                        <p>we help you to grow your business...</p>
                        <Link to="#" className="read-more">Read More</Link>
                    </article>

                </div>
            </section>


            <aside className="sidebar">
                <div className="about">
                    <h4>About Us</h4>
                    <p>We are a digital marketing agency specializing in SEO, PPC, and more.</p>
                </div>
                <div className="popular-posts">
                    <h4>Popular Posts</h4>
                    <ul>
                        <li> <Link to="#" className="Graphics Design">Graphics Design</Link></li>
                        <li><Link to="#" className="Web Design">Web Design</Link></li>
                        <li><Link to="#" className="E Commerce Marketing">E Commerce Marketing</Link></li>
                    </ul>
                </div>
            </aside>





        </>


    )
}
